import React from 'react';
import logoSrc from '../../assets/mywellfie-header-logo.png';
import {
  ADHOC_SCAN_MAINTENANCE_MESSAGE,
  ADHOC_SCAN_MAINTENANCE_PAID_MESSAGE,
} from '../../config/featureFlags';
import './landing.css';

interface Props {
  paidAfterCheckout?: boolean;
  sessionId?: string | null;
  onReturn: () => void;
}

const AdhocMaintenanceStage: React.FC<Props> = ({
  paidAfterCheckout = false,
  sessionId,
  onReturn,
}) => {
  const message = paidAfterCheckout
    ? ADHOC_SCAN_MAINTENANCE_PAID_MESSAGE
    : ADHOC_SCAN_MAINTENANCE_MESSAGE;

  return (
    <div className="adhoc-landing" style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <nav>
        <div className="wrap">
          <div className="nav-logo">
            <img src={logoSrc} alt="MyWellfie" />
          </div>
        </div>
      </nav>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 28px',
          textAlign: 'center',
          maxWidth: 520,
          margin: '0 auto',
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: '#FFFBEB',
            border: '1px solid #FDE68A',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 28,
            marginBottom: 24,
          }}
          aria-hidden
        >
          ⚙
        </div>
        <h1 style={{ fontSize: 26, fontWeight: 800, color: '#0f172a', margin: '0 0 12px' }}>
          Under maintenance
        </h1>
        <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', margin: '0 0 20px' }}>
          {message}
        </p>
        {paidAfterCheckout && sessionId && (
          <p
            style={{
              fontSize: 13,
              color: '#64748b',
              margin: '0 0 24px',
              fontFamily: 'IBM Plex Mono, monospace',
            }}
          >
            Reference: {sessionId.slice(0, 8)}…
          </p>
        )}
        <button
          type="button"
          className="btn btn-primary"
          onClick={onReturn}
          style={{ minWidth: 200 }}
        >
          Return to home
        </button>
      </div>
    </div>
  );
};

export default AdhocMaintenanceStage;
